import {environment} from '../../environments/environment';

export const CONSTANTS = {
  ACTION_COMPLETED: 'Acción completada',
  ACTION_ERROR: 'Error',
  GENERAL_ALERT: `Ha ocurrido un error interno, por favor ponte en contacto con ${environment.support_email}`,
  REQUIRED_VALUE: 'Por favor ingrese correctamente el campo',
  CODE_OK: '0000',
  CODE_ERROR: '0001',
  TITLE_ATTENTION: 'Atención',
  UNDERSTOOD: 'Entendido',
  LOCAL_DEPLOYMENT_ERROR: 'Error de despliegue en el entorno local',
  USER_UPDATE_ERROR: 'Error actualizando nombre de usuario',
  ALERT_SERVICE_BUTTON_ACCEPT: 'Aceptar',
  DEFAULT_PAYVALIDA_NAME: 'Payvalida',
  ORDER_NOT_FOUND: 'Orden no encontrada',
  EXPIRATION_MESSAGE_PART_ONE: 'Recuerda que tienes hasta ',
  EXPIRATION_MESSAGE_PART_TWO: ' para realizar tu pago.',
  PAYMENT_RECEIPT_TITLE: 'recibo_de_pago_payvalida',
};

export const CONSTANTS_UNIQUE_LINK = {
  ERROR_CONTENT: "0011",
  CODE_BAD_STRUCT_EMAIL: "0047",
  CODE_INVALID_EMAIL: "0048",
  CODE_MULTILINK_EXPIRED: "0095",
  CODE_DISABLE_MERCHANT: "0096",
  CODE_CUSTOM_EXPIRATION_MESSAGE: '0097',
  CODE_INVALID_NAME: '0066',
  DESC_COPY_CONTINUE: 'Continuar con el pago',
  DESC_BAD_MAIL: "La dirección de correo es inválida, asegúrese de escribirla correctamente.",
  DESC_MULTILINK_EXPIRED: "El link asociado a tu pago se encuentra expirado.",
  DESC_DISABLE_MERCHANT: "Al parecer el comercio que generó el link se encuentra deshabilitado.",
  DESC_PAY_LINKS_OK: 'Aquí esta tu link de pagos, al darle continuar se copiará automáticamente.',
  DESC_INVALID_NAME: 'El campo nombre no es válido.',

};

export const CONSTANTS_METHODS_NOT_FOUND = {
  RECEIVED_EMAIL_OK: 'Hemos recibido tu email satisfactoriamente',
  RECEIVED_EMAIL_DESC: 'Estaremos informándote cuando este nuevo medio de pago esté disponible'
};

export const PAYMENT_CATEGORIES = {
  BANCOLOMBIA: '9'
}

export const EMAIL_LENGTH = {
  MAX: 150,
}

export const MAX_MIN_LENGTH_PHONE_INPUT_PSE = {
  MIN_MAX : 10
}

export const MAX_MIN_ADDRESS_INPUT = {
  MAX: 50,
  MIN: 5
}
